import { UnknownAction } from "@reduxjs/toolkit";
import { jwtDecode } from "jwt-decode";
import { ThunkDispatch } from "redux-thunk";
import { User } from "../../models/user";
import { setUser } from "../../store/slices/globalSlice";
import { transformUser } from "../users/helpers";

export const updateTokens = (
  dispatch: ThunkDispatch<any, any, UnknownAction>,
  accessToken: string,
  refreshToken?: string
) => {
  localStorage.setItem("accessToken", accessToken);

  if (refreshToken) {
    localStorage.setItem("refreshToken", refreshToken);
  }

  const decodedUser: any = jwtDecode(accessToken);
  const user: User = { ...(decodedUser as User) };

  const transformedUser = transformUser(user);
  dispatch(setUser(transformedUser));
};

export const handleTokenUpdate = async (
  queryFulfilled: Promise<{ data: { accessToken: string; refreshToken?: string } }>,
  dispatch: any,
  setSSOError: boolean = false,
  logError: boolean = false
) => {
  try {
    const {
      data: { accessToken, refreshToken },
    } = await queryFulfilled;
    updateTokens(dispatch, accessToken, refreshToken);
  } catch (error) {
    if (setSSOError) {
      sessionStorage.setItem("ssoError", "ssoErr");
    }
    if (logError) {
      console.error("Error updating tokens:", error);
    }
  }
};
